// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.my-input.v-input .v-input__slot[data-v-4979d2a7] {\n    border-radius: 100px;\n}\n.chat-background[data-v-4979d2a7] {\n    background-color: #ece5dd !important;\n}\n.chat-header[data-v-4979d2a7] {\n    background-color: #075e54 !important;\n}\n.chip-chat[data-v-4979d2a7] {\n    margin: 20px;\n    padding: 10px;\n    border-radius: 20px;\n    background-color: #dcf8c6 !important;\n}\n", ""]);
// Exports
module.exports = exports;
